import TimetablingSolutions from "./core/TimetablingSolutions";
import { displaySettings } from "./resources/displaysettings";
import {
    configSettings,
    customConfigSections,
    generalSettings,
    menuData,
} from "./resources/menuitems";

import logo from "./resources/logo.svg";
import flat from "./resources/flat.svg";

TimetablingSolutions.Start(
    menuData,
    generalSettings,
    configSettings,
    customConfigSections,
    displaySettings,
    logo,
    flat,
);
